import qs from 'qs';
import { useContext } from 'react';
import type { FunctionComponent } from 'react';

import { RouterContext } from '../../../../contexts/RouterContext';
import { getBaseOrgProperties, track } from '../../../../helpers/analytics';
import CardBanner from '../../../generic/CardBanner';
import icons from '../../../generic/Icon/icons';

type SubscriptionBannerUpgradeProps = {
  hasUsedFreeTrial?: boolean,
};
const SubscriptionBannerUpgrade: FunctionComponent<SubscriptionBannerUpgradeProps> = ({
  hasUsedFreeTrial,
  children,
}) => {
  const {
    getRouter,
    getLocation,
  } = useContext(RouterContext);
  const { pathname } = getLocation();
  const isBillingPage = pathname.startsWith('/account/settings/billing');

  return (
    <CardBanner
      title="Elevate Your FOSSA Experience"
      description="Get access to powerful features and maximize your impact with the FOSSA Business Plan."
      icon={icons.arrowUpRightDots}
      cta={
        {
          text: !hasUsedFreeTrial ? 'Start Free Trial' : 'Upgrade Now!',
          onClick: () => {
            if (!hasUsedFreeTrial) {
              track(`Start Trial - Banner`, { ...getBaseOrgProperties(), page: pathname });
            }
            getRouter()
              .push(`/account/settings/billing?${qs.stringify({ tab: 'Plans' })}`);
          },
          isFullWidth: (!isBillingPage && !children),
        }
      }
      stackHeaderCta={!children}
     >
      {children}
    </CardBanner>);
};

export default SubscriptionBannerUpgrade;
